
        require('./index.scss');
        'use strict';

var _ = window._;
var $ = window.$;
var $adModel = require('model/service/advert.js');
var $modAll = $('.module-ad-rect-new');
var $mod = null;
var sync;
var cityId;
var adTmpl;
var adStyle;
var marginTop;
var marginBottom;

function pv(ele) {
    if (window.FCAdLog) {
        if (ele) {
            window.FCAdLog.elPv(ele);
        } else {
            window.FCAdLog.elPv($mod.find('[data-ad_id]'));
        }
    }
}
var sw = {
    slides: [],
    wraper: [],
    pagination: [],
    timeCtl: 0,
    slideLen: 0,
    init: function init() {
        this.slides = $mod.find('.ad-swiper-wrap .ad-swiper-item');
        this.wraper = $mod.find('.ad-swiper-wrap');
        this.pagination = $mod.find('.swiper-pagination-bullet');
        this.timeCtl = 0;
        this.slideLen = $mod.find('.ad-swiper-wrap .ad-swiper-item').length;

        this.slides.eq(0).addClass('active');
        this.wraper.show();
        this.start();
        this.bind();
        pv(this.slides.eq(0).find('[data-ad_id]'));
    },
    start: function start() {
        var that = this;
        that.timeCtl = setInterval(function () {
            var activeSlide = that.wraper.find('.ad-swiper-item.active');
            var activeIndex = activeSlide.index();
            var nextIndex = activeIndex + 1;
            if (nextIndex >= that.slideLen) {
                nextIndex = 0;
            }
            that.changeSlide(nextIndex);
            // console.log(nextIndex)
        }, 3000);
    },
    changeSlide: function changeSlide(index) {
        this.slides.eq(index).show().addClass('active').siblings().hide().removeClass('active');
        this.pagination.eq(index).addClass('swiper-pagination-bullet-active').siblings().removeClass('swiper-pagination-bullet-active');
        pv(this.slides.eq(index).find('[data-ad_id]'));
    },
    bind: function bind() {
        var that = this;
        this.pagination.on('mouseenter', function () {
            that.changeSlide($(this).index());
        });
    }
};
var _module = {
    init: function init() {
        sync = $mod.data('sync') + '';
        if (sync === '1') {
            var $modPrev = $mod.prev();
            if (!$modPrev.hasClass('module-ad-rect') && marginTop !== '') {
                $mod.css('margin-top', marginTop + 'px');
            }

            if ($mod.data('style') === 'ad200x200') {
                this.bindAd200x200($mod);
            }
        } else {
            var adPosIds = [];
            var that = this;
            $.each($mod.find('.ad-box'), function (i, v) {
                var posId = $(v).data('posid');
                adPosIds.push(posId);
                that.appendAd.call(that, { 'posId': posId });
            });
        }
    },
    bindAd200x200: function bindAd200x200($mod) {
        var $cityHotWord = $mod.parent().find('.module-city-hot-word');
        var fixLimit = 1019;
        if ($cityHotWord.length > 0) {
            fixLimit = $mod.parent().find('.module-city-hot-word').offset().top - 128 || 1019;
        }
        // var fixLimit = ($mod.parent().find('.module-city-hot-word').offset().top - 128) || 1019;
        // var top = $mod.offset().top;
        var scrollFn = _.throttle(function () {
            var hotModuleHeight = $cityHotWord.height() + 127;
            if (!$mod.parent().find('.module-city-hot-word').hasClass('fix-left') && !$mod.parent().find('.module-city-hot-word').hasClass('fix-bottom-ad')) {
                if ($cityHotWord.length > 0) {
                    fixLimit = $mod.parent().find('.module-city-hot-word').offset().top - 128 || 1019;
                }
                // fixLimit = ($mod.parent().find('.module-city-hot-word').offset().top - 128) || 1019;
                // console.log('fixLimit2:  ',fixLimit);
            }
            var scrollTop = $(window).scrollTop();
            var footTop = $mod.parents().find('#doc').find('#ft-block').offset().top;
            // console.log('scrollTop: ', scrollTop);
            if (scrollTop >= fixLimit) {
                if (scrollTop < footTop - $mod.height()) {
                    $mod.removeClass('fix-bottom');
                    $mod.addClass('fix-left').css('top', hotModuleHeight + 'px');
                }
                if ($mod.offset().top + $mod.height() >= footTop) {
                    var feedHeight = $mod.parents('#bd-row').height();
                    $mod.parent().height(feedHeight);
                    $mod.removeClass('fix-left').css('top', '');
                    $mod.addClass('fix-bottom');
                }
            } else {
                $mod.removeClass('fix-left').css('top', '');
                $mod.removeClass('fix-bottom');
            }
        }, 200);
        $(window).on('scroll', scrollFn);
    },
    adSwiper: function adSwiper() {
        var $adBox = $mod.find('.ad-swiper-item');
        var $swp = $mod.find('.swiper-pagination .swiper-pagination-bullet');
        // if($adBox.length === $mod.find('.ad-link').length){
        $adBox.eq(0).show();
        $swp.eq(0).addClass('swiper-pagination-bullet-active');
        $mod.show();
        sw.init();
        // pv();
        // }
    },
    appendAd: function appendAd(option) {
        var that = this;
        if (!cityId || !option.posId) {
            return;
        }
        $adModel.getAdData(cityId, option.posId, function (res) {
            if (res.code !== 200 && res.code !== '200') {
                return;
            }
            var $modPrev = $mod.prev();
            if (!$modPrev.hasClass('module-ad-rect') && marginTop !== '') {
                $mod.css('margin-top', marginTop + 'px');
            }
            if (!$modPrev.hasClass('module-ad-rect') && marginBottom !== '') {
                $mod.css('margin-bottom', marginBottom + 'px');
            }
            if (adStyle !== 'ad1200x120') {
                var adData = res.data.ad_map[option.posId];
                if (!adData) {
                    return;
                }
                $mod.show();

                var adHtml = velocityjs.render(adTmpl, {
                    'ad-rect': {
                        'style': adStyle,
                        'list': [adData]
                    }
                });
                var $adDom = $mod.find('.ad-box[data-posid="' + option.posId + '"]').html(adHtml);
                if (adStyle === 'ad599x40') {
                    $mod.css({ 'width': '1200px' });
                }
                $adDom.show(function () {
                    pv();
                });
            } else {
                var hasSw = false;
                $.each(res.data.ad_map, function (adCode, adData) {
                    hasSw = true;
                    var adSwHtml = velocityjs.render(adTmpl, {
                        'ad-rect': {
                            'style': adStyle,
                            'list': [adData]
                        }
                    });
                    var adSwBoxHtml = '<div class="ad-box ad-swiper-item" style="display: none;">' + adSwHtml + '</div>';
                    $mod.find('.ad-swiper-wrap[data-posid="' + option.posId + '"]').append(adSwBoxHtml).show();
                    // $adSwDom.find('.ad-swiper-item').eq(0).show();
                    // $mod.show();
                    $mod.find('.swiper-pagination').append('<div class="swiper-pagination-bullet"></div>');
                });
                if (hasSw) {
                    that.adSwiper();
                    $mod.css({ 'width': '1200px' });
                } else {
                    $mod.hide();
                }
            }
        });
    }
};
$modAll.each(function () {
    $mod = $(this);
    sync = $mod.data('sync') + '';
    cityId = $mod.data('cityid');
    adTmpl = require('./rect.html');
    adStyle = $mod.data('style');
    marginTop = $mod.data('margintop');
    marginBottom = $mod.data('marginbottom');
    _module.init();
});;
    


// WEBPACK FOOTER //
// ./src/module/ad/ad-rect-new/index.js